import type { ReactiveFormHostMode } from './reactive-form-host-state';

export interface ReactiveFormHostTitleStateOptions {
    readonly mode: ReactiveFormHostMode;
    readonly titleWhenEdit: string;
    readonly titleWhenNew: string;
    readonly titleWhenDuplicate: string;
    readonly titleWhenRead?: string | undefined;
}

/** Resolves the display title associated with the current host mode. */
export class ReactiveFormHostTitleState {
    public static resolve(options: ReactiveFormHostTitleStateOptions): string {
        switch (options.mode) {
        case 'edit':
            return options.titleWhenEdit;
        case 'duplicate':
            return options.titleWhenDuplicate;
        case 'read':
            return options.titleWhenRead ?? options.titleWhenEdit;
        case 'new':
        default:
            return options.titleWhenNew;
        }
    }
}
